// extracted by mini-css-extract-plugin
module.exports = {"not_found":"position-with-matching-criteria_not_found__YV-3G"};